import * as React from "react";
const SvgMenu2 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5, d: "M3.332 12h9.333M3.332 4h9.333M3.332 8h9.333" }));
export default SvgMenu2;
